import { Dialog, Text } from '@leroy-merlin-br/backyard-react-ui'

import { deleteRelationship } from './services'

const handleModal = (setModal, id) => {
  const modalDeleteRelationship = ({ onClose }) => (
    <Dialog
      title="Tem certeza que deseja excluir o projeto com esse profissional?"
      onClose={onClose}
      actions={[
        { color: 'green', content: 'Voltar', onClick: onClose },
        {
          content: 'Excluir',
          onClick: () => deleteRelationship(id, onClose)
        }
      ]}
    >
      <Text size="mega" noMargin>
        Você não poderá mais receber vantagens, como cupons de desconto, desse
        profissional.
      </Text>
    </Dialog>
  )

  return setModal({
    appElement: 'body',
    size: 'giga',
    children: modalDeleteRelationship
  })
}

export default handleModal
